<libero-blog-full-article-content
  [articleDetail]="articleDetail"
  [otherPosts]="otherPosts"
  [errored]="errored"
  [loading]="loading"
  [showOtherPosts]="true"
></libero-blog-full-article-content>